export default "__VITE_ASSET__u_6liPku__"